<template>
  <div class="navbox">
    <div class="navwid">
      <div class="flex leftcard">
        <div class="markbox flex">
          <div class="logobox">
            <img src="../assets/logo.jpg" alt="" />
          </div>
          <p style="margin-left: 2px; font-size: 18px">劳乐斯</p>
        </div>
        <el-menu
          :default-active="activeIndex2"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="#000000"
          text-color="#fff"
          active-text-color="#4d9bf8"
          router
        >
          <el-menu-item index="/home">{{ $t("message.home") }}</el-menu-item>
          <el-menu-item index="/product">{{
            $t("message.product")
          }}</el-menu-item>
          <el-menu-item index="/newsCenter">{{
            $t("message.newcenter")
          }}</el-menu-item>
          <el-menu-item index="/resource">{{
            $t("message.resource")
          }}</el-menu-item>
          <el-menu-item index="/aboutUs">{{
            $t("message.aboutus")
          }}</el-menu-item>
        </el-menu>
      </div>
      <div class="chbox" @click="change">简体中文/English</div>
    </div>
  </div>
</template>

<script setup >
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
import { ref } from "vue";
let change = () => {
  if (locale.value == "zh") {
    locale.value = "en";
  } else {
    locale.value = "zh";
  }
};

let activeIndex2 = ref("home");
function handleSelect(key, keyPath) {
  console.log(key, keyPath);
}
</script>
<style lang="scss" scoped>
.markbox {
  width: 100px;
  display: flex;
  align-items: center;
  margin-right: 15px;
  cursor: pointer;
  font-size: 15px;
}
.el-menu-demo {
  width: 80%;
  .floatImgWrap {
    display: flex;
    align-items: center;
    img {
      width: 30px;
      height: 30px;
    }
  }
}
.chbox {
  cursor: pointer;
}
::v-deep .el-menu--horizontal.el-menu {
  border-bottom: none;
}
.flex {
  display: fle;
}
.logobox {
  width: 40px;
  height: 40px;
  img {
    width: 100%;
    height: 100%;
  }
}
.navbox {
  width: 100%;
  background-color: #000;
  color: #fff;
  display: flex;
  justify-content: center;
}
.navwid {
  width: 1600px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.leftcard {
  width: 80%;
}
::v-deep .el-menu-demo .el-menu-item {
  font-size: 18px !important;
}
</style>